import React, { useState } from 'react'

import * as Yup from 'yup'
import { BasicForm } from '../../../../core/components/form'
import { usePostForm } from '../../../../hooks/admin/campaign'

import { useCachePriority, getPrioritiesForSelect } from '../../../../hooks/cache/priority'
import { useCacheService, getServicesForSelect } from '../../../../hooks/cache/service'
import { useCacheTag, getTagsForSelect } from '../../../../hooks/cache/tag'

import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import { Form, Input, Select, Checkbox } from 'formik-antd'
import { List, Button, Input as InputAntd, Form as FormAntd } from 'antd'

import { v4 } from 'uuid'
import { PlusOutlined } from '@ant-design/icons'
import { LAYOUT_PUBLIC_CAMPAIGN_FORM } from '../../../../layouts/public/navigation'
import { flashWarning, flashSuccess } from '../../../../core/utils/flashMessage'

const ValidationSchema = Yup.object().shape({
  type: Yup.string().required('Cannot be blank.'),
  name: Yup.string().required('Cannot be blank.').min(3, 'Must be 3 characters at minimum')
})

const getFullCampaignURL = (hash, media) => {
  return 'https://' + window.location.hostname + LAYOUT_PUBLIC_CAMPAIGN_FORM(hash, media)
}

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = () => {
  const create = usePostForm()
  const history = useHistory()
  const [mediaName, setMediaName] = useState('')

  const { data: serviceData } = useCacheService()
  const { data: priorityData } = useCachePriority()
  const { data: tagData } = useCacheTag()
  const services = getServicesForSelect(serviceData)
  const priorities = getPrioritiesForSelect(priorityData)
  const tags = getTagsForSelect(tagData)

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const form = { ...values }

    create.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = {
    name: '',
    services: [],
    type: '',
    hash: v4(),
    media: [],
    tags: [],
    priority: null,
    require_upload: false
  }

  const _addMedia = (setFieldValue, values) => {
    if (!values.media.includes(mediaName)) {
      setFieldValue('media', [...values.media, mediaName])
    }
    setMediaName('')
  }

  const _removeMedia = (setFieldValue, values, item) => {
    if (item === '') {
      flashWarning({ description: 'Cannot delete default link' })
      return
    }

    const newMedia = values.media
    const index = newMedia.indexOf(item)
    if (index > -1) {
      newMedia.splice(index, 1)
      setFieldValue('media', newMedia)
    }
  }

  const _copyClipboard = (url) => {
    navigator.clipboard.writeText(url)
    flashSuccess({ description: 'URL copied to clipboard' })
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='ADD CAMPAIGN'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ validateRequired, values, setFieldValue }) => (
        <>
          <Form.Item label='Type' name='type' hasFeedback required>
            <Select placeholder='Type' name='type' showSearch>
              <Select.Option value='vendor'>Vendor Campaign</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item name='name' label='Name' required >
            <Input name='name' />
          </Form.Item>

          <Form.Item label='Services allowed' name='services'>
            <Select
              name='services'
              style={{ width: '100%' }}
              placeholder='All'
              mode='multiple'
              options={services}
              filterOption={_filter}
            />
          </Form.Item>

          <Form.Item name='media' hidden />

          <FormAntd.Item label='Media'>
            <InputAntd.Group compact>
              <FormAntd.Item noStyle>
                <InputAntd
                  style={{ width: '160px' }}
                  value={mediaName}
                  onChange={(e) => setMediaName(e.target.value.trim())}
                />
              </FormAntd.Item>
              <Button
                icon={<PlusOutlined />}
                disabled={mediaName === ''}
                onClick={() => _addMedia(setFieldValue, values)}
              >
                Add
              </Button>
            </InputAntd.Group>

            <>
              <br />
              <List
                size='small'
                bordered
                dataSource={['', ...values.media]}
                renderItem={(item) => (
                  <List.Item
                    key={item}
                    actions={[
                      <Button
                        key='clipboard'
                        type='link'
                        onClick={() => _copyClipboard(getFullCampaignURL(values.hash, item))}
                      >
                        copy link
                      </Button>,
                      <Button
                        key='delete'
                        type='link'
                        onClick={() => _removeMedia(setFieldValue, values, item)}
                      >
                        delete
                      </Button>
                    ]}
                  >
                    <>
                      <p>{item || 'Default'}</p>
                    </>
                  </List.Item>
                )}
              />
            </>
          </FormAntd.Item>

          <Form.Item label='Default tags' name='tags'>
            <Select
              name='tags'
              style={{ width: '100%' }}
              placeholder='None'
              mode='multiple'
              options={tags}
              filterOption={_filter}
            />
          </Form.Item>

          <Form.Item label='Default priority' name='priority'>
            <Select
              name='priority'
              style={{ width: '100%' }}
              placeholder='None'
              options={priorities}
              filterOption={_filter}
              allowClear
            />
          </Form.Item>

          <Form.Item label='Require Upload(CV)' name='require_upload' hasFeedback>
            <Checkbox name='require_upload' />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
